import {Component, computed, effect, input, output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {User} from '../../../../shared/model/user';
import {UserUpdate} from '../../../../shared/model/user-update';
import {GenericFormComponent} from '../../../../shared/components/generic-form/generic-form.component';

@Component({
  selector: 'app-profile-form',
  standalone: true,
  imports: [ReactiveFormsModule, GenericFormComponent],
  templateUrl: './profile-form.component.html',
  styleUrl: './profile-form.component.css'
})
export class ProfileFormComponent {
  userData = input<User | undefined>(undefined);
  isEditing = input<boolean>(false);
  isLoading = input<boolean>(false);

  save = output<Partial<UserUpdate>>();
  cancel = output<void>();

  protected isAssociation = computed(() => {
    return this.userData()?.userType === 'ASSOCIATION';
  });

  protected isGoogleUser = computed(() => {
    return !!this.userData()?.isGoogleUser;
  });

  protected userForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.userForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      userType: [{value: 'USER', disabled: true}],
      role: [''],
      bio: [''],
      website: [''],
      city: [''],
      vatNumber: ['']
    });

    effect(() => {
      const user = this.userData();
      if (user) {
        this.userForm.patchValue({
          username: user.userName,
          email: user.email,
          userType: user.userType,
          role: user.userProfile?.role || 'PLAYER',
          bio: user.userProfile?.bio || '',
          website: user.userProfile?.website || '',
          city: user.userProfile?.city || '',
          vatNumber: user.userProfile?.vatNumber || ''
        });
      }

      if (!this.isEditing()) {
        this.userForm.disable();
      } else {
        this.userForm.enable();
        this.userForm.get('userType')?.disable();
        if (this.isGoogleUser()) {
          this.userForm.get('email')?.disable();
        }
      }
    });
  }

  onSubmit() {
    if (this.userForm.valid && this.isEditing()) {
      this.save.emit(this.userForm.value);
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}
